import { ProducerTransformerType } from 'store/producer/transformers/types.ts'
import { GetProducersSuccessPayload } from 'store/producer/thunks/types.ts'
import { ProducerStore } from 'store/producer/types.ts'

export const getProducersTransformer = ({ producers, state }: ProducerTransformerType<GetProducersSuccessPayload>): ProducerStore => {
  const ids = producers.map((prod) => Number(prod.id))
  const latestProducerID = Math.max(...ids)

  return {
    ...state,
    latestProducerID: latestProducerID,
    producers: producers
  }
}
